import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import ExperienceTimeline from "@/components/ExperienceTimeline";
import Skills from "@/components/Skills";
import Services from "@/components/Services";
import FeaturedProject from "@/components/FeaturedProject";
import PortfolioGallery from "@/components/PortfolioGallery";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Portfolio() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white relative">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <About />
        <ExperienceTimeline />
        <Skills />
        <Services />
        <FeaturedProject />
        <PortfolioGallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
